import styled from "@emotion/styled";

export const WorkspaceItemContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  box-sizing: border-box;
  padding: 16px 20px;
  width: 560px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const WorkspaceImageContainer = styled.img`
  background-color: white;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  border: none;

  object-fit: cover;
  object-position: center;
`;

export const WorkspaceEmptyImageConainer = styled.div`
  background-color: #d9d9d9;
  width: 48px;
  height: 48px;
  border-radius: 8px;
`;

export const WorkspaceInfoContainer = styled.div`
  width: 423px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const WorkspaceProfile = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const UserProfile = styled.div`
  display: flex;
  align-items: center;
`;

export const Line = styled.div`
  min-width: 1px;
  width: 1px;
  height: 32px;
  background-color: var(--alias-color-line-normal);
`;

export const PendingWorkspaceItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PendingWorkspaceInfoContainer = styled.div`
  box-sizing: border-box;
  padding: 12px 16px;
  width:100%;
  background-color: var(--global-color-yellow-95);
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-radius: 8px;
`;
